/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTabQueryResponse,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTabPathParams,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab400,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab401,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab500,
} from "../../types/courseRegistrationEnrollmentController/GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab.ts";

function getGetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTabUrl(
  courseRegistrationId: GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTabPathParams["courseRegistrationId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/courseregistration/enrollment/${courseRegistrationId}/course-access-tab` as const,
  };
  return res;
}

/**
 * @description Retorna se o acesso ao curso está liberado, período de liberação e datas de início e fim, para exibição na aba Acesso ao Curso do gerenciamento. **(Requer Authorization para autenticação)**
 * @summary Retorna dados de acesso ao curso de uma matrícula (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/enrollment/:courseRegistrationId/course-access-tab}
 */
export async function getApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab(
  courseRegistrationId: GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTabPathParams["courseRegistrationId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTabQueryResponse,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab400
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab401
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTabUrl(
      courseRegistrationId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
